import { Box, Checkbox } from '@mui/material';
import { FilterOptionType, FilterType, $FormControlLabel } from './Filter';
import { ChangeEvent } from 'react';

type CheckboxOptionProps = {
  filter: FilterType;
  option: FilterOptionType;
  onCheckboxChange: (
    filter: FilterType,
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
};

function CheckboxOption({ filter, option, onCheckboxChange }: CheckboxOptionProps) {
  return (
    <Box width="100%">
      <$FormControlLabel
        control={
          <Checkbox
            onChange={(...params) => onCheckboxChange(filter, ...params)}
            checked={!!filter?.selectedOptions?.includes(option.value)}
            value={option.value}
          />
        }
        label={
          <Box component="span" width="100%" display="flex" alignItems="center">
            {option.label}&nbsp;
            {option.badgeValue ? `(${option.badgeValue})` : ''}
          </Box>
        }
        value={option.value}
        disabled={option.disabled}
      />
    </Box>
  );
}

export default CheckboxOption;
